import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'wego-lodder',
  template: `<div [hidden]="!isLoading" class="my-loading">
                <div class="dimmer"></div>
                <div class="loading-bg">
                    <i class="fa fa-refresh fa-spin fa-3x fa-fw" style="color: #000;"></i>
                </div>
             </div>`,
  styles: [`
    .my-loading {
      position: fixed;
      top: 0;
      left: 0;
      bottom: 0%;
      right: 0%;
      text-align: center;
      z-index: 9999;
    }
    
    .my-loading .dimmer {
      position: absolute;
      top: 0;
      left: 0;
      background-color: #000;
      opacity: 0.5;
      width: 100%;
      height: 100%;
    }
    
    .my-loading .loading-bg {
      position: absolute;
      display: inline-block;
      top: 50%;
      left: -webkit-calc(50% - 40px);
      left: -moz-calc(50% - 40px);
      left: calc(50% - 40px);
      transform: translateY(-50%);
      padding: 22px;
      background-color: #fff;
      border-radius: 15px;
      text-align: center;
    }
  `]
})
export class LodderComponent implements OnInit {
  @Input('isLoading') isLoading: boolean;

  constructor() { }

  ngOnInit() { }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/lodder.component.ts